import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { SocialService } from './social.service';
import { AddThisService } from '../common/addthis.service';
import { Config } from '../universal-config';
const { version: appVersion } = require('../../../package.json');

@Component({
  selector: 'nns-social-widget',
  styles: [`
    :host {
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      border-radius: 2px;
      box-sizing:border-box;
      padding:16px;
      width:226px;
      display:block;
    }
    .nns-modal-share-title {
      font-size:15px;
      padding:0 0 10px 0;
    }

    .nns-modal-share-actions {
      border-bottom:1px solid #dcdcdc;
      margin:0 0 16px 0;
      min-height:92px;
    }

    .nns-modal-share-radios {
      padding:0 0 16px 0;
    }

    short-url {
      padding:0 0 16px 0;
      display:block;
     }

    .nns-modal-share-buttons nns-button {margin: 5px 2px}

    .short-url-info {color:#0095a7; font-weight:bold;}
  `, `
    :host-context(.nns-theme-night) {
      background: #292E32;
      border-color: #161A1E;
      box-shadow: 4px 4px 38px rgba(19, 30, 32, 0.66);
    }
    :host-context(.nns-theme-night) .nns-modal-share-actions {
      border-color:rgba(0,0,0, 0.12);
    }
    :host-context(.nns-theme-night) .nns-share-loader .fill {
      fill:#fff;
    }
    :host-context(.nns-theme-night) .nns-embed-button ::ng-deep .nns-button-layout{
      border-radius: 4px;
    }
  `],
  template: `
    <div flex layout="row">
      <div class="nns-modal-share-title">Share</div>
    </div>
    <div class="nns-modal-share-actions">
      <short-url [url]="shareUrl" [share]="share"></short-url>
    </div>
    <div class="nns-modal-share-buttons" flex
      layout="row" layout-align="start center" layout-wrap
      layout-align-sm="center center"
    >
      <div class="addthis_inline_share_toolbox"></div>
      <a title="Embed" (click)="openEmbedDialog($event)" class="nns-embed-button">
        <nns-button class="transparent icon" icon="embed"></nns-button>
      </a>
      <a title="Facebook" [href]="'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl" target="_blank" class="nns-embed-button">
        <nns-button class="transparent icon" icon="fb"></nns-button>
      </a>
      <a title="Twitter" [href]="'https://twitter.com/intent/tweet?&url=' + shareUrl" target="_blank" class="nns-embed-button">
        <nns-button class="transparent icon" icon="twitter"></nns-button>
      </a>
      <a title="Reddit" [href]="'http://www.reddit.com/submit?url=' + shareUrl" target="_blank" class="nns-embed-button">
        <nns-button class="transparent icon" icon="reddit"></nns-button>
      </a>
    </div>

    `
})
export class SocialWidgetComponent {
  @Input() public shareUrl;
  @Input() public isFolder;
  @Input() public share;
  @Output() onClick = new EventEmitter();
  shortUrl;

  constructor(
    public _store: Store<IAppState>,
    private _socialService: SocialService,
    private _addThisService: AddThisService,
    public _config: Config,
    ) {
  }

  openEmbedDialog(event) {
    this._socialService.openEmbedDialog();
    this.onClick.emit(event);
  }

  ngAfterViewInit() {
    const addThisId = this._config.get('ADD_THIS_ID');
    this._addThisService.initAddThis(addThisId, false).subscribe();
  }

}
